import { render } from "./CustomTextarea.vue?vue&type=template&id=2d7fc49d"
import script from "./CustomTextarea.vue?vue&type=script&lang=js"
export * from "./CustomTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__